import React from "react";

type AlertPopupProps = {
  message: string;
  onClose: () => void;
};

export default function AlertPopup({ message, onClose }: AlertPopupProps) {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 bg-black/60 backdrop-blur-sm">
      <div className="bg-gray-900 border border-yellow-500 rounded-xl shadow-[0_0_20px_#FFD700] p-6 max-w-sm w-full animate-pulse">
        {/* Glow header */}
        <h2 className="text-yellow-400 text-xl font-bold mb-3 text-center tracking-widest">
          ⚠ ALERT ⚠
        </h2>

        {/* Message */}
        <p className="text-white text-center mb-6">{message}</p>

        {/* Button */}
        <button
          onClick={onClose}
          className="w-full bg-yellow-500 text-black py-2 rounded-lg font-semibold 
                     hover:bg-yellow-400 hover:shadow-[0_0_15px_#FFD700] 
                     transition duration-300"
        >
          OK
        </button>
      </div>
    </div>
  );
}
